import React, { PropsWithChildren, ReactNode } from 'react';
import { ModalsKeys } from 'global';
import { ApolloError } from '@apollo/client';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { ModalsContainer } from '../Modals';
import { usePageTitle } from './usePageTitle';
import { RenderWithFallback } from '../Conditional/RenderWithFallback';
import { RenderWithCondition } from '../Conditional/RenderWithCondition';

interface Props {
  title?: string;
  loading?: boolean;
  error?: ApolloError | null;
  modals?: Partial<Record<ModalsKeys, ReactNode>>;
}

export const PageContainer = ({ modals, children, title, loading = false, error = null }: PropsWithChildren<Props>) => {
  usePageTitle(title);

  return (
    <>
      <Box
        id={`page_container_${title ?? 'no_title'}`}
        sx={{ flex: 1, height: '100%', overflow: 'auto', overflowX: 'hidden' }}
      >
        <RenderWithFallback
          isLoading={loading}
          fallBack={
            <Stack alignItems="center" justifyContent="center" height="100%">
              <CircularProgress />
            </Stack>
          }
        >
          <RenderWithCondition
            condition={!error}
            fallBack={
              <Stack alignItems="center" justifyContent="center" height="100%">
                <Typography>Something went wrong. Page unavailable.</Typography>
                <Typography>Error: {error?.message}</Typography>
              </Stack>
            }
          >
            {children}
          </RenderWithCondition>
        </RenderWithFallback>
      </Box>

      <RenderWithCondition condition={Boolean(modals)} children={<ModalsContainer modalsWithKeys={modals!} />} />
    </>
  );
};
